import React from 'react';

export default function FieldCustomisationComponent({ tableRows }) {
	return (
		<div className="p-3">
			<table className="currency-table">
				<thead>
					<tr>
						{['FIELD NAME', 'DATA TYPE', 'MANDATORY', 'STATUS'].map((item) => (
							<th>{item}</th>
						))}
					</tr>
				</thead>
				<tbody>
					{tableRows.map((data, index) => (
						<tr key={index}>
							<td>{data.field_name}</td>
							<td>{data.data_type}</td>
							<td>{data.mandatory}</td>
							<td style={{ color: data.status === 0 ? '#DC3545' : '#6AA247' }}>
								{data.status === 0 ? 'Inactive' : 'Active'}
							</td>
						</tr>
					))}
				</tbody>
			</table>
		</div>
	);
}
